module.exports = __webpack_public_path__ + "img/Vector 384 (1).cce1ab04.png";